import { ISMT_DeThi_Request } from "../../../model/request/de-thi/ISMT_DeThi_Request";
import { ISMT_DeThi_Vm } from "../../../model/respone/de-thi/ISMT_DeThi_Vm";
import { ISMT_XemDeThi } from "../../../model/respone/de-thi/ISMT_XemDeThi";
import {
  IDeThi_CauHoi,
  IDeThiActionTypes,
} from "../../action-types/de-thi/IDeThiActions";
import { IDeThiReducer } from "../../reducer-model/de-thi/IDeThiReducer";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";

const iniState: IDeThiReducer = {
  status: eReducerStatusBase.is_not_initialization,
  idSelections: [],
  deThiEditing: {} as ISMT_DeThi_Vm,
  deThis: [],
  request: {} as ISMT_DeThi_Request,
  statusChangeQuestion: eReducerStatusBase.is_completed,
  deThiCompares: [],
  examData: {} as ISMT_XemDeThi,
  examHtmlContent: "",
  tongHops: [],
  statusTongHop: eReducerStatusBase.is_not_initialization,
  requestTongHop: {
    id_dot_thi: 0,
    id_bm: 0,
    id_mon: 0,
    hoc_ky: 0,
    nam_hoc: "",
  },
};

export const deThiReducer = (
  state: IDeThiReducer = iniState,
  action: IDeThiActionTypes
): IDeThiReducer => {
  switch (action.type) {
    case "DE_THI_LOAD_START":
      return {
        ...state,
        status: eReducerStatusBase.is_loading,
        deThis: [],
      };
    case "DE_THI_LOAD_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
        deThis: action.payload,
      };
    case "DE_THI_LOAD_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "DE_THI_SAVE_START":
      return {
        ...state,
        status: eReducerStatusBase.is_saving,
      };
    case "DE_THI_SAVE_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload,
        isShowEditModal: false,
      };
    case "DE_THI_SAVE_ERROR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "DE_THI_DELETE_START":
      return {
        ...state,
        status: eReducerStatusBase.is_deleting,
      };
    case "DE_THI_DELETE_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload,
      };
    case "DE_THI_DELETE_ERROR":
      return {
        ...state,
        status: eReducerStatusBase.is_deleted,
      };
    case "DE_THI_DELETE_MULTIPLE_SUCCESS":
      return {
        ...state,
        idSelections: [],
        status: eReducerStatusBase.is_need_reload,
      };
    case "DE_THI_DELETE_MULTIPLE_ERROR":
      return {
        ...state,
        status: eReducerStatusBase.is_deleted,
      };
    case "DE_THI_SHOW_EDIT_MODAL":
      return {
        ...state,
        deThiChangeQuestion: action.payload,
        isShowEditModal: true,
      };
    case "DE_THI_CLOSE_EDIT_MODAL":
      return {
        ...state,
        deThiChangeQuestion: undefined,
        isShowEditModal: false,
      };
    case "DE_THI_SHOW_VIEW_DOICAUHOI_MODAL":
      return {
        ...state,
        isShowChangeQuestionModal: true,
        deThiChangeQuestion: action.payload,
      };
    case "DE_THI_CLOSE_VIEW_DOICAUHOI_MODAL":
      return {
        ...state,
        isShowChangeQuestionModal: false,
      };
    case "DE_THI_SELECTED_ID":
      return {
        ...state,
        idSelections: action.payload,
      };
    case "DE_THI_CHANGE_REQUEST":
      return {
        ...state,
        request: {
          ...state.request,
          ...action.payload,
        },
        status: eReducerStatusBase.is_need_reload,
      };
    case "DE_THI_LOAD_CHITIET_START":
      return {
        ...state,
        statusChangeQuestion: eReducerStatusBase.is_loading,
      };
    case "DE_THI_LOAD_CHITIET_SUCCESS":
      const id_dethi =
        action.payload?.length > 1 ? action.payload[0].id_dethi : 0;
      return {
        ...state,
        deThiCompares: state.deThiCompares.map((g) => {
          if (g.id === id_dethi) {
            return {
              ...g,
              sub: action.payload,
            };
          }
          return g;
        }),
        deThiChangeQuestion: state.deThiChangeQuestion
          ? ({
              ...state.deThiChangeQuestion,
              sub: action.payload,
            } as ISMT_DeThi_Vm)
          : state.deThiChangeQuestion,
        statusChangeQuestion: eReducerStatusBase.is_completed,
      };
    case "DE_THI_LOAD_CHITIET_ERROR":
      return {
        ...state,
        statusChangeQuestion: eReducerStatusBase.is_completed,
      };
    case "DE_THI_DOICAUHOI_SELECTED":
      return {
        ...state,
        deThiChangeQuestion: {
          ...state.deThiChangeQuestion,
          sub: [
            ...(state.deThiChangeQuestion?.sub ?? ({} as IDeThi_CauHoi[])).map(
              (g) => {
                if (g.data.id === action.payload.data.id)
                  return {
                    ...g,
                    data_change: action.payload.data_change,
                  };
                return g;
              }
            ),
          ],
        } as ISMT_DeThi_Vm,
        statusChangeQuestion: eReducerStatusBase.is_completed,
      };

    case "DE_THI_SHOW_PROGRESS_MODAL":
      return {
        ...state,
        isShowProgressModal: true,
      };
    case "DE_THI_CLOSE_PROGRESS_MODAL":
      return {
        ...state,
        isShowProgressModal: false,
      };
    case "DE_THI_PROGRESS_START":
      return {
        ...state,
        status: eReducerStatusBase.is_saving,
      };
    case "DE_THI_PROGRESS_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload,
        isShowProgressModal: false,
        idSelections: [],
      };
    case "DE_THI_PROGRESS_ERROR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "DE_THI_CHANGE_QUESTION_START":
      return {
        ...state,
        statusChangeQuestion: eReducerStatusBase.is_saving,
      };
    case "DE_THI_CHANGE_QUESTION_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload,
        statusChangeQuestion: eReducerStatusBase.is_saved,
        isShowChangeQuestionModal: false,
        isShowEditModal: false,
        deThiChangeQuestion: undefined,
      };
    case "DE_THI_CHANGE_QUESTION_ERROR":
      return {
        ...state,
        statusChangeQuestion: eReducerStatusBase.is_saved,
      };
    case "DE_THI_SHOW_COMPARE_MODAL":
      return {
        ...state,
        isShowCompareModal: true,
      };
    case "DE_THI_CLOSE_COMPARE_MODAL":
      return {
        ...state,
        isShowCompareModal: false,
      };
    case "DE_THI_ADD_COMPARE":
      if (!state.deThiCompares.some((g) => g.id === action.payload.id))
        return {
          ...state,
          deThiCompares: [...state.deThiCompares, action.payload],
        };
      return state;
    case "DE_THI_REMOVE_COMPARE":
      return {
        ...state,
        isShowCompareModal: false,
        deThiCompares: state.deThiCompares.filter(
          (g) => g.id !== action.payload.id
        ),
      };
    case "DE_THI_REMOVEALL_COMPARE":
      return {
        ...state,
        isShowCompareModal: false,
        deThiCompares: [],
      };
    case "DE_THI_SHOW_EXAM":
      return {
        ...state,
        isShowExamModal: true,
        examData: action.payload,
      };
    case "DE_THI_CLOSE_EXAM":
      return {
        ...state,
        isShowExamModal: false,
        examData: {} as ISMT_XemDeThi,
        examHtmlContent: "",
      };
    case "DE_THI_VIEW_EXAM_START":
      return {
        ...state,
        status: eReducerStatusBase.is_loading_view,
      };
    case "DE_THI_VIEW_EXAM_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_view_completed,
        examHtmlContent: action.payload as string,
      };
    case "DE_THI_VIEW_EXAM_ERROR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "DE_THI_LOAD_TONGHOP_START":
      return {
        ...state,
        statusTongHop: eReducerStatusBase.is_loading,
      };
    case "DE_THI_LOAD_TONGHOP_SUCCESS":
      return {
        ...state,
        statusTongHop: eReducerStatusBase.is_completed,
        tongHops: action.payload,
      };
    case "DE_THI_LOAD_TONGHOP_ERRR":
      return {
        ...state,
        statusTongHop: eReducerStatusBase.is_completed,
      };
    case "DE_THI_CHANGE_REQUEST_TONGHOP":
      return {
        ...state,
        statusTongHop: eReducerStatusBase.is_need_reload,
        requestTongHop: {
          ...state.requestTongHop,
          ...action.payload,
        },
      };
    default:
      return state;
  }
};
